var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 24,
    viewBox: "0 0 80 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M160 240h272v424H160z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "126.5%",
    height: "117%",
    x: "-13.2%",
    y: "-5.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.845822692 0 0 0 0 0.845822692 0 0 0 0 0.845822692 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "91.683%",
    x2: "-38.413%",
    y1: "4.677%",
    y2: "71.806%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "26.01%",
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51.22%",
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.04%",
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "107.998%",
    x2: "-130.395%",
    y1: "49.535%",
    y2: "49.535%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40.87%",
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77.54%",
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "86.472%",
    x2: "-50.626%",
    y1: "17.638%",
    y2: "195.596%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "-19.128%",
    x2: "42.092%",
    y1: "-53.645%",
    y2: "24.959%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "6.85%",
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.62%",
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80.09%",
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00F076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-300 -344)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 40,
    x: 184,
    y: 336,
    fill: "#FAFBFB",
    rx: 8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(300 344)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 24,
    fill: "#000",
    rx: 2.406
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M64.04 18.5h1.123V11H64.04v7.5zm10.11-4.799l-1.287 3.252h-.039l-1.335-3.252h-1.21l2.003 4.545-1.14 2.529h1.17l3.085-7.074H74.15zm-6.366 3.947c-.367 0-.88-.183-.88-.637 0-.579.638-.8 1.19-.8.493 0 .725.106 1.025.25a1.359 1.359 0 0 1-1.335 1.187zm.135-4.11c-.812 0-1.654.356-2.002 1.148l.996.414c.213-.414.61-.55 1.026-.55.58 0 1.17.348 1.18.966v.076a2.488 2.488 0 0 0-1.17-.289c-1.074 0-2.167.589-2.167 1.689 0 1.003.88 1.65 1.867 1.65.754 0 1.17-.338 1.431-.734h.039v.58h1.084v-2.876c0-1.332-.997-2.075-2.284-2.075zm-6.936 1.076h-1.596v-2.57h1.596c.839 0 1.316.692 1.316 1.285 0 .581-.477 1.285-1.316 1.285zM60.954 11h-2.69V18.5h1.123v-2.842h1.567c1.244 0 2.467-.898 2.467-2.33 0-1.43-1.223-2.329-2.467-2.329zm-14.665 6.65c-.776 0-1.425-.647-1.425-1.536 0-.9.65-1.557 1.425-1.557.765 0 1.366.658 1.366 1.557 0 .889-.6 1.536-1.366 1.536zm1.289-3.528h-.04c-.251-.3-.736-.57-1.346-.57-1.28 0-2.452 1.121-2.452 2.562 0 1.43 1.172 2.542 2.452 2.542.61 0 1.095-.27 1.347-.58h.039v.367c0 .977-.524 1.499-1.367 1.499-.688 0-1.114-.494-1.288-.91l-.98.407c.281.677 1.028 1.508 2.268 1.508 1.318 0 2.433-.774 2.433-2.658v-4.583h-1.066v.416zm1.84 4.379h1.125v-7.501H49.42V18.5zm2.782-2.474c-.03-.986.765-1.489 1.337-1.489.446 0 .824.222.95.541l-2.287.948zm3.488-.851c-.213-.57-.862-1.624-2.19-1.624-1.318 0-2.412 1.034-2.412 2.552 0 1.43 1.085 2.552 2.539 2.552 1.172 0 1.85-.715 2.131-1.131l-.872-.58c-.29.425-.688.705-1.26.705-.571 0-.979-.26-1.24-.773l3.421-1.411-.117-.29zm-27.253-.84v1.082h2.598c-.078.609-.282 1.053-.591 1.362-.379.378-.97.793-2.007.793-1.598 0-2.848-1.285-2.848-2.88 0-1.596 1.25-2.88 2.848-2.88a2.77 2.77 0 0 1 1.958.773l.765-.764c-.649-.619-1.511-1.093-2.723-1.093-2.19 0-4.03 1.78-4.03 3.964s1.84 3.963 4.03 3.963c1.182 0 2.074-.387 2.772-1.112.717-.715.94-1.72.94-2.533 0-.251-.02-.483-.058-.676h-3.654zm6.665 3.314c-.776 0-1.445-.638-1.445-1.546 0-.919.67-1.547 1.445-1.547s1.443.628 1.443 1.547c0 .908-.668 1.546-1.443 1.546zm0-4.098c-1.415 0-2.569 1.073-2.569 2.552 0 1.47 1.154 2.552 2.569 2.552 1.414 0 2.567-1.083 2.567-2.552 0-1.479-1.153-2.552-2.567-2.552zM40.7 17.65c-.775 0-1.443-.638-1.443-1.546 0-.919.668-1.547 1.443-1.547.776 0 1.444.628 1.444 1.547 0 .908-.668 1.546-1.444 1.546zm0-4.098c-1.414 0-2.567 1.073-2.567 2.552 0 1.47 1.153 2.552 2.567 2.552 1.415 0 2.568-1.083 2.568-2.552 0-1.479-1.153-2.552-2.568-2.552z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.621 4.483v2.234l.014.522-1.697-2.756h-.667v3.833h.591V5.942l-.014-.521 1.78 2.895h.586V4.483zM44.13 6.4c0 .412-.13.756-.389 1.021a1.28 1.28 0 0 1-.95.399c-.373 0-.693-.134-.95-.399-.259-.265-.39-.609-.39-1.021 0-.413.131-.756.39-1.022.257-.264.577-.398.95-.398s.693.134.95.398c.259.266.39.61.39 1.022m-1.34-2c-.55 0-1.015.196-1.385.581A1.98 1.98 0 0 0 40.85 6.4c0 .557.187 1.034.556 1.418.37.386.835.58 1.385.58s1.016-.194 1.385-.58c.37-.385.556-.862.556-1.418 0-.554-.187-1.03-.558-1.417A1.848 1.848 0 0 0 42.79 4.4M36.797 5.063h1.023v3.253h.591V5.063h1.022v-.58h-2.636zM35.734 8.316h.593V4.483h-.593zM31.4 5.063h1.023v3.253h.592V5.063h1.022v-.58H31.4zM28.774 8.316h2.259v-.58h-1.667V6.685h1.503v-.569h-1.503V5.063h1.667v-.58h-2.259zM28.186 6.208H26.3v.57h1.322c-.034.272-.129.49-.282.646-.26.263-.59.395-.98.395-.366 0-.688-.132-.956-.394-.268-.261-.403-.606-.403-1.025 0-.42.135-.764.403-1.026.268-.261.59-.394.957-.394.41 0 .722.136.955.418l.043.052.408-.415-.036-.043a1.579 1.579 0 0 0-.595-.431 1.935 1.935 0 0 0-.775-.161c-.542 0-1.01.193-1.39.575-.38.381-.572.86-.572 1.425 0 .564.193 1.043.573 1.424.379.381.846.575 1.389.575.566 0 1.034-.191 1.387-.567.314-.319.473-.75.473-1.282 0-.094-.01-.192-.027-.29l-.01-.052z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M.278.239C.103.423 0 .709 0 1.082V14.35c0 .372.103.658.278.843l.044.043 7.453-7.433v-.176L.322.195.278.239z",
    transform: "translate(5.414 5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M7.775 7.628v.176l2.484 2.479.057-.032 2.942-1.669c.841-.475.841-1.255 0-1.732l-2.942-1.668-.057-.032-2.484 2.478z",
    transform: "translate(5.414 5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M.278 15.194c.277.293.735.329 1.25.037l8.788-4.98-2.541-2.534-7.497 7.477z",
    transform: "translate(5.414 5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M.278.239l7.497 7.478 2.54-2.535L1.529.202A1.39 1.39 0 0 0 .854 0a.77.77 0 0 0-.576.239",
    transform: "translate(5.414 5)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.5f6c4dee8e91e2161c20527bf12df04b.svg";
export { ForwardRef as ReactComponent };